import { render, staticRenderFns } from "./OrderUpdatePaymentTotal.vue?vue&type=template&id=5d32135a"
import script from "./OrderUpdatePaymentTotal.vue?vue&type=script&lang=js"
export * from "./OrderUpdatePaymentTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports